/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Back_To_Sign_InInputs */

const en_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Back to sign in`)
};

const es_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Volver a inicio de sesión`)
};

const fr_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Retour à la connexion`)
};

const de_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Zurück zur Anmeldung`)
};

const ja_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← ログイン画面に戻る`)
};

const zh_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 返回登录`)
};

const ar_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← العودة إلى تسجيل الدخول`)
};

const id_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Kembali ke masuk`)
};

const it_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Torna all'accesso`)
};

const ru_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Вернуться к входу`)
};

const pt_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← Voltar para o login`)
};

const ko_back_to_sign_in = /** @type {(inputs: Back_To_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`← 로그인으로 돌아가기`)
};

/**
* | output |
* | --- |
* | "← Back to sign in" |
*
* @param {Back_To_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const back_to_sign_in = /** @type {((inputs?: Back_To_Sign_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Back_To_Sign_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back_to_sign_in(inputs)
	if (locale === "es") return es_back_to_sign_in(inputs)
	if (locale === "fr") return fr_back_to_sign_in(inputs)
	if (locale === "de") return de_back_to_sign_in(inputs)
	if (locale === "ja") return ja_back_to_sign_in(inputs)
	if (locale === "zh") return zh_back_to_sign_in(inputs)
	if (locale === "ar") return ar_back_to_sign_in(inputs)
	if (locale === "id") return id_back_to_sign_in(inputs)
	if (locale === "it") return it_back_to_sign_in(inputs)
	if (locale === "ru") return ru_back_to_sign_in(inputs)
	if (locale === "pt") return pt_back_to_sign_in(inputs)
	return ko_back_to_sign_in(inputs)
});